{
  "documentCategory": {
    "memos": "Boendestämmans dokument",
    "general": "Allmänt",
    "safety": "Säkerhet"
  },
  "errors": {
    "failedToLoad": "Det gick inte att ladda dokumenten",
    "failedToOpen": "Det gick inte att öppna dokumentet",
    "noDocuments": "Inga dokument"
  }
}
